// START: Menu Items Configuration

import React from 'react';
import { FiBarChart2, FiCheckSquare, FiList } from 'react-icons/fi';

// Define the types for the menu items and sub-menu items
interface SubMenuItem {
  label: string;
  path: string;
  subMenu?: SubMenuItem[];
}

interface MenuItem {
  label: string;
  icon: React.ReactElement;
  path?: string;
  subMenu?: SubMenuItem[];
  permissionKey?: string;
}

const menuItems: MenuItem[] = [
  { label: "Analytics Dashboard", icon: <FiBarChart2 />, path: "/", permissionKey: "analytics_dashboard" },
  { label: "My Task", icon: <FiCheckSquare />, path: "/my-task", permissionKey: "task_list" },
  { label: "My Todo List", icon: <FiList />, path: "/my-todo", permissionKey: "todo_list" },
];

export default menuItems;

// END: Menu Items Configuration
